import React from 'react';

const CorteCajaPrintView = ({ data }) => {
    const { rows = [], date = '', checador = '', total = 0, totalMinutos = 0, totalExcusas = 0 } = data || {};

    return (
        <html lang="es">
            <head>
                <meta charSet="utf-8" />
                <title>Corte de Caja</title>
                <style>
                    {`
                    @page {
                        size: landscape;
                        margin: 12mm;
                    }
                    * {
                        box-sizing: border-box;
                    }
                    body {
                        font-family: Arial, sans-serif;
                        color: #000;
                        background: #fff;
                        margin: 0;
                        padding: 16px;
                    }
                    .title {
                        text-align: center;
                        font-size: 20px;
                        font-weight: bold;
                        text-transform: uppercase;
                        margin-bottom: 20px;
                        letter-spacing: 0.5px;
                    }
                    .header-meta {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        font-size: 14px;
                        font-weight: bold;
                        margin-bottom: 16px;
                        padding: 0 4px;
                    }
                    .header-meta .meta-value {
                        font-weight: normal;
                        margin-left: 20px;
                    }
                    table {
                        width: 100%;
                        border-collapse: collapse;
                        font-size: 13px;
                    }
                    th {
                        padding: 8px 6px;
                        font-weight: bold;
                        text-transform: uppercase;
                        border-bottom: 2px solid #000;
                    }
                    td {
                        padding: 8px 6px;
                        border-bottom: 1px solid #e0e0e0;
                    }
                    .text-center {
                        text-align: center;
                    }
                    .text-left {
                        text-align: left;
                    }
                    .text-right {
                        text-align: right;
                    }
                    .font-bold {
                        font-weight: bold;
                    }
                    .total-row td {
                        background-color: #f0f4f8;
                        border-top: 2px solid #000;
                        padding: 8px 6px;
                        font-weight: bold;
                        font-size: 13px;
                    }
                    tfoot {
                        display: table-row-group;
                    }
                    tfoot td {
                        border-top: 2px solid #000;
                        border-bottom: none;
                        padding: 10px 6px;
                        font-weight: bold;
                        font-size: 14px;
                    }
                    @media print {
                        body {
                            padding: 0;
                        }
                    }
                `}
                </style>
            </head>
            <body>
                <div className="title">CORTE DE CAJA</div>

                <div className="header-meta">
                    <div>
                        <span>FECHA:</span>
                        <span className="meta-value">{date}</span>
                    </div>
                    <div>
                        <span>CHECADOR:</span>
                        <span className="meta-value" style={{ textTransform: 'uppercase' }}>
                            {checador || '—'}
                        </span>
                    </div>
                </div>

                <table>
                    <thead>
                        <tr>
                            <th className="text-center" style={{ width: '10%' }}>UNIDAD</th>
                            <th className="text-left" style={{ width: '36%' }}>ITINERARIO</th>
                            <th className="text-center" style={{ width: '12%' }}>HORA SALIDA</th>
                            <th className="text-right" style={{ width: '10%' }}>MINUTOS</th>
                            <th className="text-right" style={{ width: '10%' }}>IMPORTE</th>
                            <th className="text-right" style={{ width: '10%' }}>EXCUSAS</th>
                            <th className="text-center" style={{ width: '12%' }}>LE SIGUE</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row, idx) => (
                            <tr key={`print-row-${row.id || idx}`}>
                                <td className="text-center font-bold">{row.unidad}</td>
                                <td className="text-left">{row.itinerario}</td>
                                <td className="text-center">{row.horaSalida}</td>
                                <td className="text-right">{row.minutos}</td>
                                <td className="text-right font-bold">{row.importe}</td>
                                <td className="text-right">{row.excusas}</td>
                                <td className="text-center">{row.leSigue}</td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colSpan={3} className="text-right font-bold">
                                TOTAL DEL DIA
                            </td>
                            <td className="text-right font-bold">
                                {totalMinutos}
                            </td>
                            <td className="text-right font-bold">
                                {typeof total === 'number' ? `$${total}` : total}
                            </td>
                            <td className="text-right font-bold">
                                {totalExcusas}
                            </td>
                            <td />
                        </tr>
                    </tfoot>
                </table>
            </body>
        </html>
    );
};

export default CorteCajaPrintView;
